/* DeSiM 公式店 — 使い方3ステップ（sections/page-how-to-use.liquid）専用 JS。
   iPhone(iOS)/Android の切替タブだけを担当する。STEP2・STEP3 は OS で操作手順が
   実際に異なるため `data-ds-howto-for="ios|android"` を切替対象にした（STEP1の
   購入手順はOSに依らないため対象外＝常に表示）。JS無効時は既定でiOS側が
   `hidden`無しで表示されたままなので、情報は読める（Androidユーザーは
   トラブル対処のアコーディオンとLINE導線でカバー）。 */
(function () {
  'use strict';
  var toggle = document.querySelector('[data-ds-howto-toggle]');
  if (!toggle) return;

  var buttons = Array.prototype.slice.call(toggle.querySelectorAll('[data-ds-howto-os]'));
  var panels = Array.prototype.slice.call(document.querySelectorAll('[data-ds-howto-for]'));
  if (!buttons.length || !panels.length) return;

  function setOs(os) {
    buttons.forEach(function (b) {
      var active = b.getAttribute('data-ds-howto-os') === os;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    panels.forEach(function (p) {
      p.hidden = p.getAttribute('data-ds-howto-for') !== os;
    });
  }

  buttons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      setOs(btn.getAttribute('data-ds-howto-os'));
    });
  });

  setOs('ios');
})();
